// @flow
import { useSelector } from 'react-redux';
import { gql, useMutation } from '@apollo/client';

type UseDeploy = () => {
  deploy: (string, string, string[]) => void
}

const useDeploy: UseDeploy = () => {
  const { userId } = useSelector(mapStateToProps);

  const [__deploy] = useMutation(MUTATION, {
    refetchQueries: [
      'getNavData'
    ]
  });
  const deploy = (version, mode, pageVersionIds) => __deploy({
    variables: { version, userId, mode, pageVersionIds }
  });

  return {
    deploy
  };
};

const MUTATION = gql`
mutation deploy($version: String!, $userId: String, $mode: String, $pageVersionIds: [String]) {
  deploy(versionId: $version, userId: $userId, mode: $mode, pageVersionIds: $pageVersionIds)
}
`;

/* =============================================================================
=    Redux
============================================================================= */
const mapStateToProps = state => ({
  userId: state.app.user && state.app.user._id
});

export default useDeploy;
